import { render, staticRenderFns } from "./VideoTrace.vue?vue&type=template&id=5657969b&scoped=true"
import script from "./VideoTrace.vue?vue&type=script&lang=js"
export * from "./VideoTrace.vue?vue&type=script&lang=js"
import style0 from "./VideoTrace.vue?vue&type=style&index=0&id=5657969b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5657969b",
  null
  
)

export default component.exports